import React, {useEffect} from 'react';
import {BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AboutQA from './pages/AboutQA';
import QuizzesPage from './pages/QuizzesPage';
import TutorialsPage from "./pages/TutorialsPage";
import ToolsPage from "./pages/ToolsPage";
import GettingStartedPage from "./pages/GettingStarted";
import AutomationLearningPage from "./pages/AutomationLearning";
import ResourcesPage from "./pages/ResourcesPage";
import ContactPage from "./pages/ContactPage";
import InterviewQuestionsPage from "./pages/InterviewQuestionsPage";
import ReactGA from 'react-ga4';
import GlossaryPage from "./pages/GlossaryPage";
import ResumeHelperPage from "./pages/ResumeHelperPage";
import AutomationPractice from "./pages/AutomationPractice";


// Import other pages similarly
// --- 1. INITIALIZE GOOGLE ANALYTICS ---
const GA_MEASUREMENT_ID ="G-QVBM7PLYG4";
if (GA_MEASUREMENT_ID) {
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

// --- 2. CREATE A COMPONENT TO TRACK ROUTE CHANGES ---
const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (GA_MEASUREMENT_ID) {
      // Send a pageview event every time the route changes
      ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }
  }, [location]);

  return null; // This component does not render anything
};


const App = () => {
  return (
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutQA />} />
              <Route path="/tutorials" element={<TutorialsPage />} /> {/* <-- Add this route */}
              <Route path="/tools" element={<ToolsPage />} /> {/* <-- Add this route */}
              <Route path="/getting-started" element={<GettingStartedPage />} /> {/* <-- Add this route */}
              <Route path="/automation-learning" element={<AutomationLearningPage />} /> {/* <-- Add this route */}
              <Route path="/resources" element={<ResourcesPage />} /> {/* <-- Add this route */}
              <Route path="/contact" element={<ContactPage />} /> {/* <-- Add this route */}
            <Route path="/interview-questions" element={<InterviewQuestionsPage />} /> {/* <-- Add this route */}
            <Route path="/glossary" element={<GlossaryPage />} /> {/* <-- Add this route */}
            <Route path="/resume-helper" element={<ResumeHelperPage />} /> {/* <-- Add this route */}
            <Route path="/automation-practice" element={<AutomationPractice />} />

              <Route path="/quizzes" element={<QuizzesPage />} />
            {/* Add other routes here */}
          </Routes>
        </Layout>
      </Router>
  );
};

export default App;